import * as React from 'react';

import PropTypes from 'prop-types';

import {ListSummariesEmpty} from './list-summaries-empty';
import {ListSummariesErrorState} from './list-summaries-error-state';
import {ListSummary} from './list-summary';

import styles from './list-summaries.module.css';

export class ListSummaries extends React.Component {
    static propTypes = {
        listSummaries: PropTypes.array,
    };

    render() {
        return (
            <div className={styles.container}>
                {this.props.listSummaries ? (
                    this.renderContents(this.props.listSummaries)
                ) : (
                    <ListSummariesErrorState />
                )}
            </div>
        );
    }

    renderContents(listSummaries) {
        if (listSummaries.length > 0) {
            return this.props.listSummaries.map((summary) => {
                const sumValues =
                    summary.stats && summary.stats.value ? summary.stats.value.sum : null;

                return <ListSummary key={summary.id} sum={sumValues} {...summary} />;
            });
        } else {
            return <ListSummariesEmpty />;
        }
    }
}
